import { all, takeLatest } from "redux-saga/effects";

import { onLoginSaga } from "./on-login.saga";
import { UserActions } from "../../user/user.actions";
import { navigationActions, navigateToSaga } from "./navigation.sagas";

export default function*() {
  yield all([
    takeLatest(navigationActions, navigateToSaga),
    takeLatest(UserActions.LOGIN_SUCCEEDED, onLoginSaga)
  ]);
}
